<template>
  <div class="download">
    <div class="rank-container">
      <div class="rank-download-title"></div>
      <div class="rank-download-title2"></div>

      <div class="game-container">
        <div class="game-box">
          <div class="desc">——— 根据游戏登录人数、用户评分计算排行 ———</div>

          <div class="game-list" v-if="isGame">
            <div
              :class="['game-item', i < 3 ? 'game-item-top3' : '']"
              v-for="(info, i) in gameList"
              :key="info.game_id"
            >
              <div class="game-item-content" @click="jumpDetail(info)">
                <div class="sort-number-box">
                  <span v-if="i > 2" class="sort-number">{{ i + 1 }}</span>
                  <img
                    v-else
                  woyaobura  :src="require(`@/assets/images/${i + 1}.png`)"
                    class="number-img"
                    alt=""
                  />
                </div>
                
                <img class="game-logo" :src="info.logo_url" alt="" />
                <div class="game-info">
                  <div class="game-info-title">
                    <h1>{{ info.game_name }}</h1>
                    <span>{{ info.discount }}</span>
                  </div>
                  <div class="game-info-desc">
                    <div class="game-info-gift">
                      <span v-if="info.wealf">福利</span>
                      <span v-if="!info.wealf && info.havaGift == 1">礼包</span>
                      <span v-if="info.isBTgame">变态特权</span>
                      <span v-if="info.waterMark == 1">专属折扣</span>
                      <span
                        v-if="
                          info.havaGift == 0 &&
                          !info.isBTgame &&
                          !info.wealf &&
                          info.waterMark == 0
                        "
                        >{{ info.title }}</span
                      >
                    </div>
                    <div class="star" v-if="info.starInfo">
                      <img
                        :key="star"
                        v-for="star in info.starInfo.allStar"
                        src="@/assets/images/star_all.png"
                        alt=""
                      />
                      <img
                        :key="star+999"
                        v-for="star in info.starInfo.halfStar"
                        src="@/assets/images/star_half.png"
                        alt=""
                      />
                    </div>
                  </div>
                  <div class="game-tag">
                    <span v-for="tag in info.formatGameType" :key="tag">{{
                      tag
                    }}</span>
                    <span class="other-tag">{{ info.openServerDate }}</span>
                  </div>
                </div>
              </div>
              <!-- <div class="game-item-operate">
                <span @click="doRecharge(info, 'recharge')">充值</span>
                <span @click="doRecharge(info, 'download')">下载</span>
              </div> -->
              <operateBtns :gameInfo="info" @doOperate="doOperate" />
            </div>
          </div>
          <van-loading v-else size="24px" vertical>加载中...</van-loading>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { requestMethods } from "@m/api";
import { mapGetters } from "vuex";
import mixins from "@/mixin/game.js";
import operateBtns from "@/components/OperateBtns.vue"
export default {
  mixins: [mixins],
  components: {
    operateBtns
  },
  data() {
    return {
      gameList: [],
      currentPage: 1,
    };
  },
  computed: {
    ...mapGetters(["uuid"]),
    isGame() {
      return this.gameList.length;
    },
  },
  mounted() {
    this.gameListQr();
  },
  methods: {
    /**
     * 根据分类查询游戏列表
     */
    async gameListQr() {
      this.gameList = [];
      try {
        const { data, totalCount } = await requestMethods(
          "/modules/operate/userOperateRecord/fetGameList.htm",
          "post",
          {
            searchParams: JSON.stringify({
              gameType: "",
              location: "GAME_LIST",
            }),
            operateType: 'DOWNLOAD',
            uuid: this.uuid,
            appType: "WM",
            currentPage: this.currentPage,
            pageSize: 20,
          }
        );
        console.log(this, "this==");
        let list = this.gameInit(data);
        this.gameList = list;
        this.totalCount = totalCount;
      } catch (error) {
        this.$toast({
          message: error.message,
          position: "bottom",
        });
      }
    },

    doOperate(info, operate) {
      this.$emit("doOperate", info, operate);
    },

    jumpDetail(info) {
      this.$router.push({
        path: "/detail",
        query: {
          gameId: info.game_id,
        },
      });
    },
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/views/rank/components/Download.vue